import { NgModule } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import {A11yModule} from '@angular/cdk/a11y';
import {MatButtonModule} from '@angular/material/button';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatGridListModule} from '@angular/material/grid-list';
import {MatListModule} from '@angular/material/list';
import {MatSelectModule} from '@angular/material/select';

import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatFormFieldModule } from '@angular/material/form-field';
import { CommonModule } from '@angular/common';

import { ImpressionEtiquetteTemplateComponent } from './impression-etiquette-template.component';
import { ListeDocumentsModule } from './liste-documents/liste-documents.module';


@NgModule({
    imports: [
        CommonModule,
        BrowserAnimationsModule,
        MatFormFieldModule,
        BrowserModule,
        A11yModule,
        MatButtonModule,
        MatButtonToggleModule,
        MatCheckboxModule,
        MatDialogModule,
        MatGridListModule,
        MatListModule,
        MatSelectModule,
        ListeDocumentsModule
      ],
      declarations: [
        ImpressionEtiquetteTemplateComponent
      ],
      exports: [
        ListeDocumentsModule,
        ImpressionEtiquetteTemplateComponent
      ],
      entryComponents: [
        ImpressionEtiquetteTemplateComponent
      ]
    })
export class ImpressionEtiquetteTemplateModule{}